











































import { defineComponent } from '@nuxtjs/composition-api';
import BaseLink from '@shared/components/@atoms/BaseLink/BaseLink.vue';

export default defineComponent({
  name: 'BaseBreadcrumbs',
  inject: {
    components: {
      default: { BaseLink },
    },
  },
  props: {
    breadcrumbs: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: 'breadcrumb',
    },
  },
  data(...args): any {
    return args;
  },
  // @ts-ignore migrated from ui-library
  breadcrumbLast(breadcrumbs) {
    return breadcrumbs.length - 1;
  },
});
